/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('enums', [
  'platforms',
  'lwanvers',
  'nodetypes',
  'bands',
  'vendors',
]);

function platforms() {
  return createAPIAction(types.platforms, {
    endpoint: '/lora/enum/platform',
  })();
}

function lwanvers() {
  return createAPIAction(types.lwanvers, {
    endpoint: '/lora/enum/lwanvers',
  })();
}

function nodetypes() {
  return createAPIAction(types.nodetypes, {
    endpoint: '/lora/enum/nodetypes',
  })();
}

function vendors() {
  return createAPIAction(types.vendors, {
    endpoint: '/lora/enum/vendor',
  })();
}

function bands() {
  return createAPIAction(types.bands, {
    endpoint: '/lora/enum/bands',
  })();
}

export default {
  platforms,
  lwanvers,
  nodetypes,
  bands,
  vendors,
};




// WEBPACK FOOTER //
// ./src/redux/actions/enums.js